'use strict';

export let mapspath = "https://map.tamrielma.ps/tm-restyle/";
// export let datapath = mapspath+"data/";
export let datapath = "https://geo.tamrielma.ps/";
//export let datapath = "../geoJson/";

function getNormalizedCoord(coord, zoom) {
    const y = coord.y;
    let x = coord.x;
    const tileRange = 1 << zoom;
    if (y < 0 || y >= tileRange) {
        return null;
    }
    if (x < 0 || x >= tileRange) {
        x = (x % tileRange + tileRange) % tileRange;
    }
    return {x: x, y: y};
}

export function createGameMapType(type, tilesUrl) {
    const gameTypeOptions = {
        getTileUrl(coord, zoom) {
            const normalizedCoord = getNormalizedCoord(coord, zoom);
            if (!normalizedCoord) {
                return null;
            }
            const boundnorm = Math.pow(2, zoom);
//            return tilesUrl + "/" + zoom + "/" + normalizedCoord.x + "/" + (boundnorm - normalizedCoord.y - 1) + ".png";
            return tilesUrl + "/" + zoom + "/" + normalizedCoord.x + "/" + normalizedCoord.y + ".jpg";
            
        },
        tileSize: new google.maps.Size(256, 256),
        isPng: false,
        maxZoom: 6,
        minZoom: 1,
        radius: 1738000,
        name: type
    };
    return new google.maps.ImageMapType(gameTypeOptions);
}